import { Chapter, Reveal } from "@/components/aklive/motion";
import { PlaceholderBlock } from "@/components/aklive/PlaceholderBlock";

const BLOCKS = [
  { service: "Brand Identity", outcome: "Be recognised.", label: "[BRAND SYSTEM — LANDSCAPE]", ratio: "3 / 2" },
  { service: "Website", outcome: "Be understood.", label: "[WEBSITE MOCKUP — 16:9]", ratio: "16 / 9" },
  { service: "Pitch Deck", outcome: "Make the opportunity clear.", label: "[PITCH DECK SPREAD — 3:2]", ratio: "3 / 2" },
  { service: "Packaging", outcome: "Shape perception.", label: "[PACKAGING CLOSE-UP — 4:5]", ratio: "4 / 5" },
  { service: "Content Systems", outcome: "Stay consistent.", label: "[CONTENT SYSTEM — 1:1]", ratio: "1 / 1" },
  { service: "Events", outcome: "Create an experience.", label: "[EVENT PHOTO — PORTRAIT]", ratio: "4 / 5" },
];

export const Purpose = () => (
  <section className="py-24 md:py-40" data-testid="purpose-section">
    <div className="container-ak">
      <Chapter index="03" label="Design with purpose" />
      <div className="grid gap-y-16 md:grid-cols-2 md:gap-x-10 md:gap-y-24 lg:gap-x-16">
        {BLOCKS.map((b, i) => (
          <Reveal key={b.service} delay={(i % 2) * 0.1} className={i % 2 === 1 ? "md:mt-20" : ""}>
            <article className="group" data-testid={`purpose-block-${i}`}>
              <div className="overflow-hidden">
                <PlaceholderBlock
                  label={b.label}
                  ratio={b.ratio}
                  className="transition-transform duration-500 ease-out group-hover:scale-[1.03]"
                />
              </div>
              <div className="mt-5 flex items-baseline gap-4">
                <span className="font-mono text-[10px] tracking-[0.2em] text-ember">0{i + 1}</span>
                <h3 className="font-display text-xl font-bold uppercase tracking-tight text-ink md:text-2xl">
                  {b.service}
                </h3>
              </div>
              <p className="mt-1 pl-8 text-base text-ink2 md:text-lg">{b.outcome}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
